export default __webpack_public_path__ + "assets/bae399b14379cba9d190ce96b22d6d31.png";